<script>
import axios from '@/utils/axios';

export default {
    inject: ['setLoading'],
    data() {
        return {
            errors: {},
            step: 1,
            id: '',
            challan_number: '',
            client_type: 'Engineer',
            recipient_type: 'App\\Models\\Engineer',
            recipient_id: null,
            warehouse_id: null,
            store_person_id: null,
            storePersons: [],
            dispatch_date: '',
            reference_no: '',
            transporter_name: '',
            vehicle_no: '',
            purpose: '',
            status: '',
            subtotal: 0,
            tax_amount: 0,
            total: 0,
            tax_breakdown: {},

            // Dropdown data
            recipients: [],
            warehouses: [],
            taxes: [],
            products: [],
            brands: [],

            // Items
            items: [
                { brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null, available_qty: null }
            ],

            // For view detail
            documents: [null],
            documentNames: [''],
            detail: null,
            module_url: 'inventory/delivery-challans'
        };
    },

    methods: {

        async onBrandSelect(index, brandId) {
            const row = this.items[index];
            row.brand_id = brandId;
            row.item_id = null;
            row.name = '';
            row.unit_price = 0;
            row.tax_id = null;
            row.items_list = [];
            row.available_qty = null;

            if (!brandId) return;

            try {
                const response = await axios.get(`/items/${brandId}/brand-wise`);
                row.items_list = response.data.data || [];
            } catch (error) {
                this.$swalToast('Failed to load items for selected brand', 'error');
            }
        },

        async onItemSelect(index, itemId) {
            const row = this.items[index];
            if (!itemId) {
                row.item_id = null;
                row.name = '';
                row.quantity = 1;
                row.unit_price = 0;
                row.tax_id = null;
                row.available_qty = null;
                return;
            }
            const product = row.items_list.find(p => p.id === itemId);
            if (product) {
                row.unit_price = parseFloat(product.price || 0);
                row.name = product.name || '';
                row.tax_id = product.tax_id || null;
            }
            // 
            if (this.warehouse_id && itemId) {
                try {
                    const res = await axios.get(`/inventory/stocks/item-stock/${this.warehouse_id}/${itemId}`);
                    row.available_qty = res.data.data?.available_qty ?? 0;
                } catch (e) {
                    row.available_qty = 0;
                }
            }
        },

        // 
        async onWarehouseChange() {
            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i];
                if (this.warehouse_id && item.item_id) {
                    try {
                        const res = await axios.get(`/inventory/stocks/item-stock/${this.warehouse_id}/${item.item_id}`);
                        item.available_qty = res.data.data?.available_qty ?? 0;
                    } catch (e) {
                        item.available_qty = 0;
                    }
                } else {
                    item.available_qty = null;
                }
            }
        },

        // async loadDropdowns(skipRecipients = false) {
        //     try {
        //         const [warehouseRes, taxRes, brandRes, storePersonRes] = await Promise.all([
        //             axios.get('/inventory/warehouses/dropdown'),
        //             axios.get('/taxes'),
        //             axios.get('/brands/dropdown'),
        //             axios.get('/store-persons/dropdown'),
        //         ]);

        //         const getArray = (res) => {
        //             const d = res.data.data;
        //             return Array.isArray(d) ? d : (d?.data || []);
        //         };

        //         this.warehouses = getArray(warehouseRes);
        //         this.taxes = getArray(taxRes);
        //         this.brands = brandRes.data.data || [];
        //         this.storePersons = storePersonRes.data.data || [];

        //         if (!skipRecipients) {
        //             await this.loadRecipients(this.client_type);
        //         }
        //     } catch (error) {
        //         console.log('Dropdown load error:', error.message);
        //     }
        // },



async loadDropdowns() {
    try {
        const [warehouseRes, taxRes, brandRes, storePersonRes] = await Promise.all([
            axios.get('/inventory/warehouses/dropdown'),
            axios.get('/taxes'),
            axios.get('/brands/dropdown'),
            axios.get('/store-persons/dropdown'),
        ]);

        const getArray = (res) => {
            const d = res.data.data;
            return Array.isArray(d) ? d : (d?.data || []);
        };

        this.warehouses = getArray(warehouseRes);
        this.taxes = getArray(taxRes);
        this.brands = brandRes.data.data || [];
        this.storePersons = storePersonRes.data.data || [];
    } catch (error) {
        console.log('Dropdown load error:', error.message);
    }
},

        // async loadRecipients(type) {
        //     try {
        //         const urlMap = {
        //             'Engineer': '/engineers/dropdown',
        //             'Customer': '/customers/dropdown-for-dc',
        //             'WorkOrder': '/work-orders/dropdown',
        //             'SalesExecutive': '/sales-executives/dropdown',
        //             'InternalConsumption': '/internal-consumptions/dropdown',
        //         };

        //         const url = urlMap[type];
        //         if (!url) return;

        //         const res = await axios.get(url);
        //         const d = res.data.data;
        //         this.recipients = Array.isArray(d) ? d : (d?.data || []);
        //     } catch (error) {
        //         console.log('Recipients load error:', error.message);
        //     }
        // },

        async onRecipientSearch(search) {
    if (!search || search.length < 2) return;

    const urlMap = {
        'Engineer': '/engineers/dropdown',
        'Customer': '/customers/dropdown-for-dc',
        'WorkOrder': '/work-orders/dropdown',
        'SalesExecutive': '/sales-executives/dropdown',
        'InternalConsumption': '/internal-consumptions/dropdown',
    };

    const url = urlMap[this.client_type];
    if (!url) return;

    try {
        const res = await axios.get(url, { params: { search_keyword: search } });
        const d = res.data.data;
        this.recipients = Array.isArray(d) ? d : (d?.data || []);
    } catch (error) {
        console.log('Recipients search error:', error.message);
    }
},

        // onClientTypeChange() {
        //     this.recipient_id = null;
        //     this.recipients = [];

        //     const typeMap = {
        //         'Engineer': 'App\\Models\\Engineer',
        //         'Customer': 'App\\Models\\Customer',
        //         'WorkOrder': 'App\\Models\\WorkOrder',
        //         'SalesExecutive': 'App\\Models\\SalesExecutive',
        //         'InternalConsumption': 'App\\Models\\InternalConsumption',
        //     };
        //     this.recipient_type = typeMap[this.client_type] || 'App\\Models\\Engineer';

        //     this.loadRecipients(this.client_type);
        // },

        onClientTypeChange() {
            this.recipient_id = null;
            this.recipients = [];

            const typeMap = {
                'Engineer': 'App\\Models\\Engineer',
                'Customer': 'App\\Models\\Customer',
                'WorkOrder': 'App\\Models\\WorkOrder',
                'SalesExecutive': 'App\\Models\\SalesExecutive',
                'InternalConsumption': 'App\\Models\\InternalConsumption',
            };
            this.recipient_type = typeMap[this.client_type] || 'App\\Models\\Engineer';
        },

        getRecipientLabel(row) {
            if (this.client_type === 'Engineer') {
                return row.user?.name || row.name || '-';
            } else if (this.client_type === 'Customer') {
                return row.company_name || row.name || '-';
            } else if (this.client_type === 'WorkOrder') {
                return row.name || '-';
            } else if (this.client_type === 'SalesExecutive') {
                return row.user?.name || row.name || '-';
            } else if (this.client_type === 'InternalConsumption') {
                return row.name || '-';
            }
        },

        async openChallan(row = null) {
            this.resetForm();

            if (row !== null) {
                if (row.recipient_type === 'App\\Models\\Customer') {
                    this.client_type = 'Customer';
                    this.recipient_type = 'App\\Models\\Customer';
                } else if (row.recipient_type === 'App\\Models\\WorkOrder') {
                    this.client_type = 'WorkOrder';
                    this.recipient_type = 'App\\Models\\WorkOrder';
                } else if (row.recipient_type === 'App\\Models\\SalesExecutive') {
                    this.client_type = 'SalesExecutive';
                    this.recipient_type = 'App\\Models\\SalesExecutive';
                } else if (row.recipient_type === 'App\\Models\\InternalConsumption') {
                    this.client_type = 'InternalConsumption';
                    this.recipient_type = 'App\\Models\\InternalConsumption';
                } else {
                    this.client_type = 'Engineer';
                    this.recipient_type = 'App\\Models\\Engineer';
                }

                await this.loadDropdowns();

                this.id = row.id;
                this.challan_number = row.challan_number;
                this.recipient_id = row.recipient_id;
                if (row.recipient) {
                    this.recipients = [row.recipient];
                }
                this.warehouse_id = row.warehouse_id;
                this.dispatch_date = row.dispatch_date ? row.dispatch_date.substring(0, 10) : '';
                this.reference_no = row.reference_no;
                this.transporter_name = row.transporter_name;
                this.vehicle_no = row.vehicle_no;
                this.purpose = row.purpose;
                this.status = row.status;
                this.store_person_id = row.store_person_id;

                if (row.challan_items && row.challan_items.length) {
                    this.items = row.challan_items.map(item => ({
                        brand_id: item.item?.brand_id || null,
                        item_id: item.item_id,
                        items_list: [],
                        name: item.name,
                        quantity: item.quantity,
                        unit_price: parseFloat(item.unit_price),
                        tax_id: item.tax_id,
                        available_qty: null,
                    }));

                    for (let i = 0; i < this.items.length; i++) {
                        if (this.items[i].brand_id) {
                            try {
                                const res = await axios.get(`/items/${this.items[i].brand_id}/brand-wise`);
                                this.items[i].items_list = res.data.data || [];
                            } catch (e) {
                                console.log('Brand items load error:', e.message);
                            }
                        }
                        // Edit mode available_qty 
                        if (this.warehouse_id && this.items[i].item_id) {
                            try {
                                const res = await axios.get(`/inventory/stocks/item-stock/${this.warehouse_id}/${this.items[i].item_id}`);
                                this.items[i].available_qty = res.data.data?.available_qty ?? 0;
                            } catch (e) {
                                this.items[i].available_qty = 0;
                            }
                        }
                    }
                }

            } else {
                await this.loadDropdowns();
            }
        },

        addItem() {
            this.items.push({ brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null, available_qty: null });
        },

        removeItem(index) {
            if (this.items.length > 1) {
                this.items.splice(index, 1);
            }
        },

        // Validation added before opening doc modal
        validateForm() {
            this.errors = {};
            let valid = true;

            if (!this.recipient_id) {
                this.$swalToast('Please select a recipient', 'error');
                return false;
            }
            if (!this.warehouse_id) {
                this.$swalToast('Please select a warehouse', 'error');
                return false;
            }
            if (!this.dispatch_date) {
                this.$swalToast('Please select dispatch date', 'error');
                return false;
            }

            // Items validation
            for (let i = 0; i < this.items.length; i++) {
                if (!this.items[i].item_id) {
                    this.$swalToast(`Please select an item for row ${i + 1}`, 'error');
                    return false;
                }
                if (!this.items[i].quantity || this.items[i].quantity < 1) {
                    this.$swalToast(`Please enter a valid quantity for row ${i + 1}`, 'error');
                    return false;
                }
            }

            return valid;
        },

async saveChallan() {
    this.errors = {};

    if (!this.validateForm()) return;

    // Check at least 1 document uploaded
    const hasDoc = this.documents.some(d => d !== null);
    if (!hasDoc) {
        this.$swalToast('Please upload at least one document.', 'error');
        return;
    }

    this.setLoading(true);
    try {
        const formData = new FormData();
        formData.append('recipient_type', this.recipient_type);
        formData.append('recipient_id', this.recipient_id);
        formData.append('warehouse_id', this.warehouse_id);
        formData.append('dispatch_date', this.dispatch_date);
        formData.append('reference_no', this.reference_no || '');
        formData.append('transporter_name', this.transporter_name || '');
        formData.append('vehicle_no', this.vehicle_no || '');
        formData.append('purpose', this.purpose || '');
        formData.append('store_person_id', this.store_person_id || '');

        if (this.id) {
            formData.append('id', this.id);
        }

        // Multiple documents
        this.documents.forEach((file) => {
            if (file) {
                formData.append('documents[]', file);
            }
        });

        this.items.forEach((item, index) => {
            const product = item.items_list.find(p => p.id === item.item_id);
            formData.append(`items[${index}][item_id]`, item.item_id || '');
            formData.append(`items[${index}][name]`, product?.name || item.name || '');
            formData.append(`items[${index}][quantity]`, item.quantity);
            formData.append(`items[${index}][unit_price]`, item.unit_price);
            formData.append(`items[${index}][tax_id]`, item.tax_id || '');
        });

        const response = await axios.post(`/${this.module_url}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.resetForm();
        this.$closeModal('challan_modal');
    } catch (error) {
        if (error.type == 'validation' && typeof error.errors === 'object') {
            this.errors = error.errors;
        } else if (error.type == 'validation' && typeof error.errors === 'string') {
            this.$swalToast(error.errors, 'error');
        } else {
            this.$swalToast(error.message, 'error');
        }
    } finally {
        this.setLoading(false);
    }
},

       addDocumentSlot() {
    this.documents.push(null);
    this.documentNames.push('');
},

    removeDocumentSlot(index) {
        if (this.documents.length > 1) {
            this.documents.splice(index, 1);
            this.documentNames.splice(index, 1);
        }
    },

onDocumentChange(index, event) {
    const file = event.target.files[0];
    if (file) {
        this.documents[index] = file;
        this.documentNames[index] = file.name;
    }
    // Reset input so same file can be re-selected
    event.target.value = '';
},

        async viewChallan(id) {
            this.setLoading(true);
            try {
                const response = await axios.get(`/${this.module_url}/${id}`);
                this.detail = response.data.data;
            } catch (error) {
                this.$swalToast(error.message, 'error');
            } finally {
                this.setLoading(false);
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return '-';
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        },

        formatCurrency(val) {
            return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },

        statusBadge(status) {
            const map = {
                draft: 'bg-warning-subtle text-warning',
                dispatched: 'bg-success-subtle text-success',
                received: 'bg-info-subtle text-info',
                cancelled: 'bg-danger-subtle text-danger',
            };
            return map[status] || 'bg-secondary-subtle text-secondary';
        },

        resetForm() {
            this.step = 1;
            this.id = '';
            this.challan_number = '';
            this.client_type = 'Engineer';
            this.recipient_type = 'App\\Models\\Engineer';
            this.recipient_id = null;
            this.warehouse_id = null;
            this.dispatch_date = '';
            this.reference_no = '';
            this.transporter_name = '';
            this.vehicle_no = '';
            this.purpose = '';
            this.status = '';
            this.subtotal = 0;
            this.tax_amount = 0;
            this.total = 0;
            this.errors = {};
            this.recipients = [];
            this.documents = [null];
            this.documentNames = [''];
            this.items = [{ brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null, available_qty: null }];
            this.store_person_id = null;
            this.storePersons = [];
        },

    },
};
</script>


<template>

    <!-- ═══════════════════════════════════════════════
         ADD / EDIT DELIVERY CHALLAN — FULLSCREEN MODAL
    ═══════════════════════════════════════════════ -->
    <div class="modal fade" id="challan_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-fullscreen" style="margin:0;">
            <div class="modal-content border-0 h-100" style="border-radius:0;">

                <!-- ░░ MAIN CONTENT ░░ -->
                <div class="dc-main">

                    <!-- Topbar -->
                    <div class="dc-topbar">
                        <div>
                            <div class="dc-page-title">{{ id ? 'Edit Delivery Challan' : 'Create Delivery Challan' }}</div>
                            <div class="dc-page-sub">{{ id ? 'Update challan details below' : 'Fill in the details to create a new delivery challan' }}</div>
                        </div>
                        <button type="button" class="dc-close-btn" data-bs-dismiss="modal">
                            <i class="ti ti-x"></i>
                        </button>
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="saveChallan" class="d-flex flex-column" style="flex:1;overflow:hidden;">

                        <div class="dc-body">

                            <!-- ── 1. Challan Details ── -->
                            <div class="dc-card">
                                <div class="dc-card-head">
                                    <div class="dc-card-icon" style="background:#fff0f0;"><i class="ti ti-truck-delivery" style="color:#e84040;"></i></div>
                                    <span class="dc-card-title">Challan Information</span>
                                </div>
                                <div class="dc-card-body">
                                    <div class="row g-3">

                                        <div class="col-md-3">
                                            <label class="dc-label">Client Type <span class="req">*</span></label>
                                            <vue-select
                                                :options="[
                                                    { label: 'Engineer', value: 'Engineer' },
                                                    { label: 'Customer', value: 'Customer' },
                                                    { label: 'Work Order', value: 'WorkOrder' },
                                                    { label: 'Sales Executive', value: 'SalesExecutive' },
                                                    { label: 'Internal Consumption', value: 'InternalConsumption' }
                                                ]"
                                                label="label"
                                                :reduce="o => o.value"
                                                v-model="client_type"
                                                @update:modelValue="onClientTypeChange"
                                                placeholder="Select Client Type"
                                            />
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">
                                                {{ client_type === 'Engineer' ? 'Engineer' : client_type === 'WorkOrder' ? 'Work Order' : client_type === 'SalesExecutive' ? 'Sales Executive' : client_type === 'InternalConsumption' ? 'Internal Consumption' : 'Customer' }}
                                                <span class="req">*</span>
                                            </label>
                                            <vue-select :options="recipients" :get-option-label="getRecipientLabel"
                                                v-model="recipient_id" :reduce="r => r.id"
                                                :placeholder="'Search ' + client_type + '...'"
                                                :filterable="false"
                                                @search="onRecipientSearch" />
                                            <div v-if="errors.recipient_id" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.recipient_id[0] }}</div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">Warehouse <span class="req">*</span></label>
                                            <!-- onWarehouseChange added to refresh available qty -->
                                            <vue-select :options="warehouses" label="name" v-model="warehouse_id"
                                                :reduce="w => w.id" placeholder="Select Warehouse"
                                                @update:modelValue="onWarehouseChange" />
                                            <div v-if="errors.warehouse_id" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.warehouse_id[0] }}</div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">Store Person</label>
                                            <vue-select
                                                :options="storePersons"
                                                :get-option-label="row => row.user?.name || row.name || '-'"
                                                v-model="store_person_id"
                                                :reduce="r => r.id"
                                                placeholder="Select Store Person"
                                            />
                                            <div v-if="errors.store_person_id" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.store_person_id[0] }}</div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">Dispatch Date <span class="req">*</span></label>
                                            <input type="date" class="dc-input" v-model="dispatch_date" />
                                            <div v-if="errors.dispatch_date" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.dispatch_date[0] }}</div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">Reference No</label>
                                            <input type="text" class="dc-input" v-model="reference_no" placeholder="Enter reference no" />
                                            <div v-if="errors.reference_no" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.reference_no[0] }}</div>
                                        </div>

                                        <div class="col-md-3">
                                            <label class="dc-label">Purpose</label>
                                            <input type="text" class="dc-input" v-model="purpose" placeholder="Enter purpose" />
                                            <div v-if="errors.purpose" class="dc-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.purpose[0] }}</div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <!-- ── 2. Transport Details ── -->
                            <div class="dc-card">
                                <div class="dc-card-head">
                                    <div class="dc-card-icon" style="background:#eff6ff;"><i class="ti ti-truck" style="color:#3b82f6;"></i></div>
                                    <span class="dc-card-title">Transport Details</span>
                                </div>
                                <div class="dc-card-body">
                                    <div class="row g-3">
                                        <div class="col-md-4">
                                            <label class="dc-label">Transporter Name</label>
                                            <input type="text" class="dc-input" v-model="transporter_name" placeholder="Enter transporter name" />
                                        </div>
                                        <div class="col-md-4">
                                            <label class="dc-label">Vehicle No</label>
                                            <input type="text" class="dc-input" v-model="vehicle_no" placeholder="Enter vehicle number" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Challan Summary bar -->
                            <div class="dc-card" v-if="recipient_id || warehouse_id || dispatch_date">
                                <div class="dc-card-head">
                                    <div class="dc-card-icon" style="background:#f0fdf4;"><i class="ti ti-clipboard-check" style="color:#22c55e;"></i></div>
                                    <span class="dc-card-title">Challan Summary</span>
                                </div>
                                <div class="dc-card-body" style="padding:12px 16px;">
                                    <div style="display:flex;flex-wrap:wrap;gap:10px;">
                                        <!-- Type -->
                                        <div class="dc-summary-chip">
                                            <span class="dc-summary-chip-icon" style="background:#fff0f0;">
                                                <i class="ti ti-users" style="color:#e84040;"></i>
                                            </span>
                                            <div>
                                                <span class="dc-summary-chip-label">Type</span>
                                                <span class="dc-summary-chip-value">{{ client_type }}</span>
                                            </div>
                                        </div>
                                        <!-- Recipient -->
                                        <div class="dc-summary-chip" style="flex:1.5;min-width:160px;">
                                            <span class="dc-summary-chip-icon" style="background:#eef6ff;">
                                                <i class="ti ti-user-circle" style="color:#3b82f6;"></i>
                                            </span>
                                            <div style="overflow:hidden;">
                                                <span class="dc-summary-chip-label">Recipient</span>
                                                <span class="dc-summary-chip-value" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">
                                                    {{ recipients.find(r => r.id === recipient_id) ? getRecipientLabel(recipients.find(r => r.id === recipient_id)) : '-' }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- Warehouse -->
                                        <div class="dc-summary-chip">
                                            <span class="dc-summary-chip-icon" style="background:#f0faf0;">
                                                <i class="ti ti-building-warehouse" style="color:#22c55e;"></i>
                                            </span>
                                            <div>
                                                <span class="dc-summary-chip-label">Warehouse</span>
                                                <span class="dc-summary-chip-value">{{ warehouses.find(w => w.id === warehouse_id)?.name || '-' }}</span>
                                            </div>
                                        </div>
                                        <!-- Date -->
                                        <div class="dc-summary-chip">
                                            <span class="dc-summary-chip-icon" style="background:#fef9ee;">
                                                <i class="ti ti-calendar" style="color:#f59e0b;"></i>
                                            </span>
                                            <div>
                                                <span class="dc-summary-chip-label">Dispatch Date</span>
                                                <span class="dc-summary-chip-value">{{ dispatch_date || '-' }}</span>
                                            </div>
                                        </div>
                                        <!-- Store Person -->
                                        <div class="dc-summary-chip" v-if="store_person_id">
                                            <span class="dc-summary-chip-icon" style="background:#faf0ff;">
                                                <i class="ti ti-user-check" style="color:#a855f7;"></i>
                                            </span>
                                            <div>
                                                <span class="dc-summary-chip-label">Store Person</span>
                                                <span class="dc-summary-chip-value">
                                                    {{ storePersons.find(s => s.id === store_person_id) ? (storePersons.find(s => s.id === store_person_id)?.user?.name || storePersons.find(s => s.id === store_person_id)?.name || '-') : '-' }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- ── 3. Line Items ── -->
                            <div class="dc-card">
                                <div class="dc-card-head">
                                    <div class="dc-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                                    <span class="dc-card-title">Challan Items</span>
                                    <button type="button" class="dc-add-item-btn ms-auto" @click="addItem">
                                        <i class="ti ti-plus"></i> Add Item
                                    </button>
                                </div>
                                <div class="dc-card-body">

                                    <div v-if="errors.items" class="dc-err-msg" style="margin-bottom:10px;">
                                        <i class="ti ti-alert-circle"></i>{{ errors.items[0] }}
                                    </div>

                                    <div v-for="(item, index) in items" :key="index" class="dc-item-card">
                                        <div class="dc-item-num">{{ index + 1 }}</div>

                                        <div class="row g-2 align-items-end">

                                            <div class="col-md-3">
                                                <label class="dc-label">Brand</label>
                                                <vue-select
                                                    :options="brands"
                                                    label="name"
                                                    v-model="item.brand_id"
                                                    :reduce="b => b.id"
                                                    placeholder="Select Brand"
                                                    @update:modelValue="onBrandSelect(index, $event)"
                                                />
                                            </div>

                                            <div class="col-md-4">
                                                <label class="dc-label">Item <span class="req">*</span></label>
                                                <vue-select
                                                    :options="item.items_list"
                                                    label="name"
                                                    v-model="item.item_id"
                                                    :get-option-label="i => `${i.name} - ${i.code ?? i.id}`"
                                                    :reduce="p => p.id"
                                                    placeholder="Select Item"
                                                    :disabled="!item.brand_id"
                                                    @update:modelValue="onItemSelect(index, $event)"
                                                />
                                                <div v-if="errors[`items.${index}.item_id`]" class="dc-err-msg">
                                                    <i class="ti ti-alert-circle"></i>{{ errors[`items.${index}.item_id`][0] }}
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <label class="dc-label">Quantity <span class="req">*</span></label>
                                                <input type="number" class="dc-input" v-model="item.quantity" min="1" placeholder="1" />
                                            </div>

                                            <!-- Available Qty -->
                                            <div class="col-md-2">
                                                <label class="dc-label">Available Qty</label>
                                                <div style="padding:7px 0;min-height:35px;display:flex;align-items:center;">
                                                    <span v-if="item.available_qty !== null" class="badge"
                                                        :class="item.available_qty > 0 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'"
                                                        style="font-size:12px;font-weight:600;padding:5px 12px;border-radius:20px;">
                                                        {{ item.available_qty }}
                                                    </span>
                                                    <span v-else style="color:#cbd5e1;font-size:15px;line-height:1;">—</span>
                                                </div>
                                            </div>

                                            <div class="col-md-1 d-flex align-items-end" style="padding-bottom:2px;">
                                                <button type="button" class="dc-remove-btn" @click="removeItem(index)" v-if="items.length > 1">
                                                    <i class="ti ti-trash"></i>
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                                        <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                                        No items added yet.
                                    </div>

                                </div>
                            </div>

                            <!-- ── 5. Documents ── -->
                            <div class="dc-card">
                                <div class="dc-card-head">
                                    <div class="dc-card-icon" style="background:#faf0ff;"><i class="ti ti-file-upload" style="color:#a855f7;"></i></div>
                                    <span class="dc-card-title">Documents <span style="color:#f43f5e;font-size:10px;margin-left:4px;">* At least 1 required</span></span>
                                    <button type="button" class="dc-add-item-btn ms-auto" @click="addDocumentSlot">
                                        <i class="ti ti-plus"></i> Add More
                                    </button>
                                </div>
                                <div class="dc-card-body">

                                    <div v-for="(doc, index) in documents" :key="index" class="dc-doc-row">
                                        <div class="dc-doc-num">{{ index + 1 }}</div>

                                        <!-- Not uploaded yet -->
                                        <div v-if="!documentNames[index]" class="dc-doc-dropzone">
                                            <div style="flex:1;display:flex;flex-direction:column;align-items:center;gap:4px;cursor:pointer;" @click="$refs['docInput' + index][0].click()">
                                                <i class="ti ti-cloud-upload" style="font-size:20px;color:#a855f7;"></i>
                                                <span>Click to upload</span>
                                                <small>PDF, JPG, PNG (Max 1MB)</small>
                                            </div>
                                            <button v-if="documents.length > 1" type="button" class="dc-remove-btn" style="position:absolute;top:8px;right:8px;width:26px;height:26px;" @click="removeDocumentSlot(index)">
                                                <i class="ti ti-x" style="font-size:12px;"></i>
                                            </button>
                                        </div>

                                        <!-- Uploaded — show file name -->
                                        <div v-else class="dc-doc-file">
                                            <div style="display:flex;align-items:center;gap:8px;overflow:hidden;">
                                                <i class="ti ti-file-filled" style="font-size:18px;color:#a855f7;flex-shrink:0;"></i>
                                                <span style="font-size:12px;font-weight:500;color:#374151;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ documentNames[index] }}</span>
                                            </div>
                                            <button type="button" class="dc-remove-btn" style="width:26px;height:26px;" @click="removeDocumentSlot(index)">
                                                <i class="ti ti-x" style="font-size:12px;"></i>
                                            </button>
                                        </div>

                                        <input
                                            type="file"
                                            :ref="'docInput' + index"
                                            style="display:none;"
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            @change="onDocumentChange(index, $event)"
                                        />
                                    </div>

                                    <div v-if="errors.documents" class="dc-err-msg" style="margin-top:8px;">
                                        <i class="ti ti-alert-circle"></i>{{ errors.documents[0] }}
                                    </div>

                                </div>
                            </div>

                        </div><!-- /dc-body -->

                        <!-- Footer -->
                        <div class="dc-footer">
                            <button type="button" class="dc-btn dc-btn-ghost me-auto" @click="addItem">
                                <i class="ti ti-plus"></i> Add Item
                            </button>
                            <button type="button" class="dc-btn dc-btn-ghost" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button type="submit" class="dc-btn dc-btn-primary">
                                <i class="ti ti-device-floppy"></i> {{ id ? 'Update' : 'Save' }} Challan
                            </button>
                        </div>

                    </form>
                </div>

            </div>
        </div>
    </div>

    <!-- ===== VIEW DETAIL MODAL ===== -->
    <div class="modal fade" id="challan_detail_modal" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

                <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
                    <div style="display:flex;align-items:center;gap:10px;">
                        <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
                            <i class="ti ti-file-description" style="font-size:17px;color:#e84040;"></i>
                        </span>
                        <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
                            {{ detail?.challan_number || 'Delivery Challan' }}
                        </h4>
                        <span v-if="detail?.status" class="badge rounded-pill ms-2" :class="statusBadge(detail.status)">
                            {{ detail.status.charAt(0).toUpperCase() + detail.status.slice(1) }}
                        </span>
                    </div>
                    <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="ti ti-x"></i>
                    </button>
                </div>

                <div class="modal-body" style="padding:20px;max-height:75vh;overflow-y:auto;" v-if="detail">

                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:0;">
                        <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Challan No</span>
                            <span style="font-size:13px;color:#1a1d23;font-weight:500;">{{ detail.challan_number }}</span>
                        </div>
                        <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Dispatch Date</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ formatDate(detail.dispatch_date) }}</span>
                        </div>
                        <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Recipient</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.recipient?.user?.name || detail.recipient?.company_name || detail.recipient?.name || '-' }}</span>
                        </div>
                        <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Warehouse</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.warehouse?.name || '-' }}</span>
                        </div>
                        <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Reference No</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.reference_no || '-' }}</span>
                        </div>
                        <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Purpose</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.purpose || '-' }}</span>
                        </div>
                        <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Transporter</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.transporter_name || '-' }}</span>
                        </div>
                        <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                            <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Vehicle No</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ detail.vehicle_no || '-' }}</span>
                        </div>
                    </div>

                    <div style="border-top:1px dashed #f0f1f5;margin:16px 0;"></div>

                    <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:10px;">Items</div>

                    <div style="border:1px solid #f0f1f5;border-radius:8px;overflow:hidden;">
                        <table class="table table-responsive" style="margin:0;font-size:13px;">
                            <thead>
                                <tr style="background:#f8f9fb;">
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">#</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Item</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">HSN</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Qty</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Unit Price</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Tax</th>
                                    <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in detail.challan_items" :key="item.id">
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ index + 1 }}</td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;font-weight:500;">
                                        {{ item.item?.name || item.name }}
                                        <br><span class="text-muted" style="font-size:11px;">{{ item.item?.code || '' }}</span>
                                    </td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ item.hsn_code || '-' }}</td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ item.quantity }}</td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ formatCurrency(item.unit_price) }}</td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ formatCurrency(item.tax_amount) }}</td>
                                    <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;font-weight:600;">{{ formatCurrency(item.total) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="display:flex;justify-content:flex-end;margin-top:16px;">
                        <div style="min-width:250px;">
                            <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f4f5f8;">
                                <span style="font-size:12px;color:#9e9e9e;">Subtotal</span>
                                <span style="font-size:13px;color:#1a1d23;">{{ formatCurrency(detail.subtotal) }}</span>
                            </div>
                            <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f4f5f8;">
                                <span style="font-size:12px;color:#9e9e9e;">Tax</span>
                                <span style="font-size:13px;color:#1a1d23;">{{ formatCurrency(detail.tax_amount) }}</span>
                            </div>
                            <div style="display:flex;justify-content:space-between;padding:8px 0;">
                                <span style="font-size:13px;font-weight:700;color:#1a1d23;">Total</span>
                                <span style="font-size:14px;font-weight:700;color:#e84040;">{{ formatCurrency(detail.total) }}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-else class="modal-body text-center p-5">
                    <span class="text-muted">Loading...</span>
                </div>

            </div>
        </div>
    </div>

</template>


<style scoped>
/* ─────────────────────────────────────────────
   DELIVERY CHALLAN — FULLSCREEN UI
───────────────────────────────────────────── */

.dc-main {
    flex: 1; display: flex; flex-direction: column; overflow: hidden;
    background: #f1f5f9;
}

.dc-topbar {
    background: #fff; border-bottom: 1px solid #e2e8f0;
    padding: 12px 22px;
    display: flex; align-items: center; justify-content: space-between;
    flex-shrink: 0;
}
.dc-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.dc-page-sub { font-size: 11px; color: #94a3b8; }
.dc-close-btn {
    width: 30px; height: 30px; border-radius: 7px;
    background: #f1f5f9; border: 1px solid #ef4444;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; font-size: 13px; transition: all .15s;
    color: #ef4444;
}
.dc-close-btn:hover { background: #fee2e2; }

.dc-body {
    flex: 1; overflow-y: auto; padding: 18px 22px;
    scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.dc-body::-webkit-scrollbar { width: 4px; }
.dc-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }

.dc-card {
    background: #fff; border: 1px solid #e2e8f0;
    border-radius: 12px; margin-bottom: 14px;
}
.dc-card-head {
    display: flex; align-items: center; gap: 9px;
    padding: 10px 16px; background: #f8fafc;
    border-bottom: 1px solid #e8edf3;
    border-radius: 12px 12px 0 0;
}
.dc-card-icon {
    width: 24px; height: 24px; border-radius: 6px;
    display: flex; align-items: center; justify-content: center;
    font-size: 12px; flex-shrink: 0;
}
.dc-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.dc-card-body { padding: 14px 16px; }

.dc-label {
    font-size: 11px; font-weight: 600; color: #475569;
    margin-bottom: 4px; display: block;
}
.dc-label .req { color: #f43f5e; margin-left: 2px; }

.dc-input {
    width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
    padding: 0 11px; font-size: 12.5px; color: #1e293b;
    background: #fff; outline: none; height: 35px;
    transition: border-color .15s, box-shadow .15s;
}
.dc-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}

.dc-err-msg {
    font-size: 10.5px; color: #f43f5e; margin-top: 3px;
    display: flex; align-items: center; gap: 3px;
}

/* ✅ Summary chips */
.dc-summary-chip {
    flex: 1; min-width: 120px;
    background: #fff; border: 1px solid #eef0f6;
    border-radius: 8px; padding: 10px 12px;
    display: flex; align-items: center; gap: 8px;
}
.dc-summary-chip-icon {
    display: inline-flex; align-items: center; justify-content: center;
    width: 30px; height: 30px; border-radius: 6px; flex-shrink: 0;
    font-size: 14px;
}
.dc-summary-chip-label {
    font-size: 10px; color: #9e9e9e; text-transform: uppercase;
    letter-spacing: 0.4px; display: block;
}
.dc-summary-chip-value {
    font-size: 13px; font-weight: 600; color: #1a1d23;
}

.dc-item-card {
    background: #fff; border: 1.5px solid #e8edf3;
    border-radius: 10px; padding: 14px 14px 10px;
    margin-bottom: 10px; position: relative;
    transition: border-color .15s, box-shadow .15s;
}
.dc-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.dc-item-num {
    position: absolute; top: -9px; left: 14px;
    width: 19px; height: 19px; background: #e84040; color: #fff;
    border-radius: 50%; font-size: 9px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
}
.dc-remove-btn {
    width: 30px; height: 30px; border-radius: 7px;
    background: #fff0f3; border: 1.5px solid #fecdd3;
    color: #f43f5e; font-size: 13px; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all .15s;
}
.dc-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }

.dc-add-item-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 7px 14px; background: #eff6ff;
    border: 1.5px dashed #93c5fd; border-radius: 8px;
    color: #2563eb; font-size: 11.5px; font-weight: 600;
    cursor: pointer; transition: all .15s;
}
.dc-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }

.dc-footer {
    background: #fff; border-top: 1px solid #e2e8f0;
    padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0;
}

.dc-btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 7px 15px; border-radius: 8px; font-size: 12px;
    font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
    transition: all .15s; text-decoration: none; white-space: nowrap;
}
.dc-btn-primary {
    background: linear-gradient(135deg,#e84040,#ef4444);
    color: #fff; border-color: #e84040;
    box-shadow: 0 2px 8px rgba(232,64,64,.25);
}
.dc-btn-primary:hover { background: linear-gradient(135deg,#dc2626,#e84040); }
.dc-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.dc-btn-ghost:hover { background: #f1f5f9; }

:deep(.vs__dropdown-toggle) {
    border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
    min-height: 35px !important; padding: 0 8px !important;
    transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
    font-size: 12px !important; color: #1e293b !important;
    background: #eff6ff !important; border: 1px solid #bfdbfe !important;
    border-radius: 5px !important;
}
:deep(.vs__dropdown-option) {
    white-space: normal !important;
    word-break: break-word;
    padding: 8px 12px;
    font-size: 12.5px;
    line-height: 1.4;
}
:deep(.vs__dropdown-option--highlight) {
    background: #fff0f0 !important;
    color: #e84040 !important;
}
.dc-doc-row {
    position: relative;
    margin-bottom: 10px;
    padding-left: 30px;
}
.dc-doc-num {
    position: absolute; top: 50%; left: 0; transform: translateY(-50%);
    width: 19px; height: 19px; background: #a855f7; color: #fff;
    border-radius: 50%; font-size: 9px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
}
.dc-doc-dropzone {
    border: 2px dashed #e2e8f0; border-radius: 10px;
    padding: 16px; text-align: center;
    display: flex; flex-direction: column; align-items: center; gap: 4px;
    transition: border-color .15s, background .15s;
    position: relative;
}
.dc-doc-dropzone span { font-size: 12px; font-weight: 500; color: #64748b; }
.dc-doc-dropzone small { font-size: 10px; color: #94a3b8; }
.dc-doc-dropzone:hover { border-color: #a855f7; background: #faf5ff; }
.dc-doc-file {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 14px; border: 1.5px solid #e2e8f0; border-radius: 8px;
    background: #f8fafc;
}
</style>